import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = {
  key: 0,
  class: "visit-stats__head"
}
const _hoisted_3 = {
  key: 1,
  class: "visit-stats__state"
}
const _hoisted_4 = {
  key: 2,
  class: "visit-stats__state visit-stats__state--error"
}
const _hoisted_5 = { class: "visit-stats__summary" }
const _hoisted_6 = { class: "visit-stats__row visit-stats__row--today" }
const _hoisted_7 = { class: "visit-stats__row" }
const _hoisted_8 = { class: "visit-stats__row" }
const _hoisted_9 = { class: "visit-stats__pageviews" }
const _hoisted_10 = {
  class: "visit-stats__chart",
  "aria-label": "최근 7일 방문자"
}
const _hoisted_11 = { class: "visit-stats__bars" }
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "visit-stats__bar-label" }

import { onMounted, ref } from 'vue'
import { fetchAdminVisitStats, type PortalVisitStats } from '@/api/portalVisit'


export default /*@__PURE__*/_defineComponent({
  __name: 'VisitorStatsWidget',
  props: {
    plain: { type: Boolean }
  },
  setup(__props: any) {



const emptyStats = (): PortalVisitStats => ({
  todayVisitors: 0,
  todayPageviews: 0,
  yesterdayVisitors: 0,
  yesterdayPageviews: 0,
  totalVisitors: 0,
  totalPageviews: 0,
  last7days: [],
  todaySources: [],
  yesterdaySources: [],
  totalSources: [],
})

const loading = ref(true)
const error = ref('')
const stats = ref<PortalVisitStats>(emptyStats())

const formatCount = (value: number) => Number(value || 0).toLocaleString('ko-KR')

const weekdayLabel = (ymd: string) => {
  const [year, month, day] = ymd.split('-').map(Number)
  if (!year || !month || !day) return ''
  return ['일', '월', '화', '수', '목', '금', '토'][new Date(year, month - 1, day).getDay()]
}

const formatDateLabel = (ymd: string) => {
  const [year, month, day] = ymd.split('-')
  if (!year || !month || !day) return ymd
  return `${month}.${day}`
}

const barHeight = (visitors: number) => {
  const max = Math.max(1, ...stats.value.last7days.map((day) => day.visitors))
  const ratio = Math.max(0.08, visitors / max)
  return `${Math.round(ratio * 56)}px`
}

onMounted(async () => {
  try {
    stats.value = await fetchAdminVisitStats()
  } catch (err) {
    error.value = err instanceof Error ? err.message : '방문자 통계를 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["visit-stats", { 'visit-stats--plain': __props.plain }]),
    "aria-labelledby": __props.plain ? undefined : 'visit-stats-title'
  }, [
    (!__props.plain)
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("h2", {
            id: "visit-stats-title",
            class: "visit-stats__title"
          }, "방문자 통계", -1)
        ]))]))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "불러오는 중입니다."))
      : (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(error.value), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("dl", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("dt", null, "오늘", -1)),
                _createElementVNode("dd", null, [
                  _createTextVNode(_toDisplayString(formatCount(stats.value.todayVisitors)), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("em", null, "명", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("dt", null, "어제", -1)),
                _createElementVNode("dd", null, [
                  _createTextVNode(_toDisplayString(formatCount(stats.value.yesterdayVisitors)), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("em", null, "명", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[6] || (_cache[6] = _createElementVNode("dt", null, "누적", -1)),
                _createElementVNode("dd", null, [
                  _createTextVNode(_toDisplayString(formatCount(stats.value.totalVisitors)), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("em", null, "명", -1))
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_9, [
              _cache[7] || (_cache[7] = _createTextVNode(" 오늘 페이지뷰 ", -1)),
              _createElementVNode("strong", null, _toDisplayString(formatCount(stats.value.todayPageviews)), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "visit-stats__chart-label" }, "최근 7일", -1)),
              _createElementVNode("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stats.value.last7days, (day) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: day.date
                  }, [
                    _createElementVNode("span", {
                      class: "visit-stats__bar",
                      style: _normalizeStyle({ height: barHeight(day.visitors) }),
                      title: `${formatDateLabel(day.date)} ${formatCount(day.visitors)}명`
                    }, null, 12, _hoisted_12),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(weekdayLabel(day.date)), 1)
                  ]))
                }), 128))
              ])
            ])
          ], 64))
  ], 10, _hoisted_1))
}
}

})